import { render, staticRenderFns } from "./carousel-style.vue?vue&type=template&id=4c7844f8&scoped=true&"
import script from "./carousel-style.vue?vue&type=script&lang=js&"
export * from "./carousel-style.vue?vue&type=script&lang=js&"
import style0 from "./carousel-style.vue?vue&type=style&index=0&id=4c7844f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7844f8",
  null
  
)

export default component.exports